import { render, staticRenderFns } from "./Serii.vue?vue&type=template&id=3cc25ce2"
import script from "./Serii.vue?vue&type=script&lang=js"
export * from "./Serii.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports